import { ReactNode } from 'react';
import { Box } from '@mui/material';
import { Typography } from '@sweep-io/sweep-design';
import { highlightMatch } from '../../../lib/highlightMatch';
import { SearchSelectItem } from './selectTypes';

export const DEFAULT_EMPTY_RESULTS_MESSAGE = 'No results found';

export const defaultItemRenderer = (item: SearchSelectItem, search?: string) => (
  <>{highlightMatch(item.label, search)}</>
);

export const maybeRenderEmptyResults = (
  emptyResultsMessage: string | undefined,
  hasItems: boolean
): ReactNode => {
  if (emptyResultsMessage && !hasItems) {
    return (
      <Box pl={1} pb={1}>
        <Typography variant="caption">{emptyResultsMessage}</Typography>
      </Box>
    );
  }
  return null;
};
